import posthog from 'posthog-js'
import { User } from "@/common/constants/interfaces"
import { FileInfo, FileStatus } from "@/common/services/FileCenter"
import userAgentUtils from "@/common/utils/userAgent";
import { formatDate, formatFileSize, getFileStatusText } from "@/common/utils/utils";
import { Watermark } from "@/common/components/FileCenterProvider";


/**
 *  上报开始批处理的信息
 */
export function reportStartBatch(batchType: string, fileInfos: FileInfo[], watermarks: Watermark[]) {

    const count = fileInfos.length;

    const data = {
        batchType,
        total_count: count,
        OS: userAgentUtils.getOS(),
        watermarks: watermarks,
        fileInfos: fileInfos.map(fileInfo => ({
            imgType: fileInfo.file.type,
            imgSize: `${fileInfo.image.width}x${fileInfo.image.height}`,
            fileSize: formatFileSize(fileInfo.file.size),
            status: getFileStatusText(fileInfo.status),
            fileFailedRecord: fileInfo.fileFailedRecord?.log,
            fileName: fileInfo.file.name,
        }))
    }
    posthog.capture('start_batch_photo', data);
}

/**
 *  上报每次图片批处理的详情
 */
export function reportBatchDetail(batchId: number, batchType: string, fileInfos: FileInfo[], watermarks: Watermark[]) {

    const count = fileInfos.length;
    const successCount = fileInfos.filter(fileInfo => fileInfo.status === FileStatus.Success).length;
    const failCount = fileInfos.filter(fileInfo => fileInfo.status === FileStatus.Failure).length;;

    const data = {
        batchId,
        batchType,
        total_count: count,
        success_count: successCount,
        fail_count: failCount,
        OS: userAgentUtils.getOS(),
        watermarks: watermarks,
        fileInfos: fileInfos.map(fileInfo => ({
            imgType: fileInfo.file.type,
            imgSize: `${fileInfo.image.width}x${fileInfo.image.height}`,
            fileSize: formatFileSize(fileInfo.file.size),
            status: getFileStatusText(fileInfo.status),
            fileFailedRecord: fileInfo.fileFailedRecord?.log,
            fileName: fileInfo.file.name,
        }))
    }
    posthog.capture('batch_photo', data);
}

// 点击批量处理且权限验证通过后上报
export function reportClickBatchBtnAfterVerify(batchType: string) {
    const data = {
        batchType,
    }
    posthog.capture('click_batch_btn_after_verify', data);
}

// 点击批量处理时没有上传图片时上报
export function reportNoPhotos(batchType: string) {
    const data = {
        batchType,
    }
    posthog.capture('no_photo', data);
}

export function reportNoFreeCount(user: User | undefined | null, batchType: string, fileCount: number) {
    const data = {
        free_count: user ? user.free_count : -1,
        batchType,
        fileCount,
    }
    posthog.capture('no_free_count', data);
}

export function reportNotEnoughFreeCount(user: User | undefined | null, batchType: string, fileCount: number) {
    const data = {
        use_time: formatDate(new Date()),
        free_count: user ? user.free_count : -1,
        batchType,
        fileCount,
    }
    posthog.capture('not_enough_free_count', data);
}

// 打开登录面板
export function reportOpenLoginPanel() {
    posthog.capture('open_login_panel');
}

// 上报检查登录失败的信息
export function reportCheckLoginFailed(qrKey: string) {
    const data = {
        qrKey,
    }
    posthog.capture('check_login_failed', data);
}

export function reportOpenVipPanel() {
    posthog.capture('open_vip_panel');
}

export function reportClickPayBtn(productId: number) {
    const data = {
        productId,
    }
    posthog.capture('click_pay_btn', data);
}

export function reportCreateOrderFailed(productId: number, error: string) {
    const data = {
        productId,
        error,
    }
    posthog.capture('create_order_failed', data);
}

export function reportCreateOrderSuccess(productId: number) {
    const data = {
        productId,
    }
    posthog.capture('create_order_success', data);
}

export function reportCheckPayFailed(orderNumber: string, error: string) {
    const data = {
        orderNumber,
        error,
    }
    posthog.capture('check_pay_failed', data);
}

// 用户取消了 系统请求目录权限的操作
export function reportCancelDirWrite() {
    posthog.capture('cancel_dir_write');
}

// 浏览器请求目录权限时，用户在选择目录时取消了操作
export function reportAddDirHandleFailed(error: string) {
    const data = {
        error,
    }
    posthog.capture('add_dir_handle_failed', data);
}

// 浏览器请求目录权限时，用户在选择目录时取消了操作
export function reportRequestError(url: string, params: any, error: string) {
    const data = {
        url,
        params,
        error,
    }
    posthog.capture('request_error', data);
}